import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SimyoStepperService {
  private currentStepNumber = 0;

  constructor() { }

  setCurrentStep(step: number) {
    this.currentStepNumber = step;
  }

  getCurrentStep() {
    return this.currentStepNumber;
  }
} 